import { Link } from "react-router-dom";
import { notFoundSvg } from "utils/assets_exports/images";

const Error = () => {
    return (
        <div className="error-container">
            <div className="error-wrapper">
                <div className="error-inner has-text-centered">
                    <div className="bg-number dark-inverted">404</div>
                    <img className="light-image" src={notFoundSvg} alt="" />
                    <img className="dark-image" src={notFoundSvg} alt="" />
                    <h3 className="dark-inverted">
                        We couldn't find that page
                    </h3>
                    <p>
                        Looks like we couldn't find that page. Please try again
                        or contact an administrator if the problem persists.
                    </p>
                    <div className="button-wrap">
                        <Link
                            to="/"
                            className="button h-button is-primary is-elevated"
                        >
                            Take me Back
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Error;
